<template>
  <v-footer height="auto" class="px-6 app--footer">
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="3">
          <p class="footer-title">{{ appTitle }}</p>
          <ul>
            <li><el-byla :byla="naudotojoVadovas" with-name no-icon /></li>
            <li><div class="pagalba" @click="gotoPagaba()">Pagalba</div></li>
          </ul>
        </v-col>

        <v-col cols="12" sm="3">
          <p class="footer-title">
            Darbui su TURTAS naudotinos šios naršyklės:
          </p>
          <ul>
            <li>Mozilla Firefox (nuo 88 versijos)</li>
            <li>Google Chrome (nuo 91 versijos)</li>
            <li>Edge (nuo 91 versijos)</li>
          </ul>
          <p class="footer-text">
            Rekomenduojama ekrano rezoliucija yra nuo 1024x768 iki 1920x1080,
            priartinimas - 100%
          </p>
        </v-col>
        <v-col cols="12" sm="6" class="text-right">
          <img :src="computeLogo" class="logo mb-2" alt="Registrų centras" />
          <v-spacer />
        </v-col>
      </v-row>
      <v-divider class="mt-5"></v-divider>
      <v-row>
        <v-col cols="12" sm="10">
          <p class="address mt-2">
            © Valstybės įmonė Registrų centras | Studentų g. 39, 08106 Vilnius |
            el. pristatymo dėžutės adresas 124110246.
            <br />Duomenys kaupiami ir saugomi Juridinių asmenų registre, kodas
            124110246.
          </p>
        </v-col>
        <v-col cols="12" sm="2">
          <div class="version text-end" v-if="showVersija">
            {{ versija }}
          </div>
        </v-col>
      </v-row>
      <v-spacer />
    </v-container>
  </v-footer>
</template>
<script>
import userRole from '../../../mixins/userRole'

export default {
  name: 'AppFooter',
  mixins: [userRole],
  data() {
    return {
      showVersija: false,
      back_build: null,
    }
  },

  computed: {
    computeLogo() {
      return '/static/rclogo.png'
    },
    appVersija() {
      return process.env.VUE_APP_PACKAGE_VERSION ?? '0.0.0'
    },
    frontVersija() {
      return process.env.VUE_APP_FRONT_BUILD ?? '0'
    },
    backVersija() {
      return this.back_build ?? '0'
    },
    versija() {
      return `v${this.appVersija} (${this.frontVersija}.${this.backVersija})`
    },
    naudotojoVadovas() {
      if (this.roleRG) {
        return {
          key: 'naudotojo-vadovas-registratorius',
          byl_url: `naudotojo-vadovas-registratorius`,
          byl_pavadinimas: 'Naudotojo vadovas registratoriams.pdf',
          icon_title: 'Naudotojo vadovas',
        }
      }
      return {
        key: 'naudotojo-vadovas',
        byl_url: `naudotojo-vadovas`,
        byl_pavadinimas: 'Naudotojo vadovas.pdf',
        icon_title: 'Naudotojo vadovas',
      }
    },
  },
  created() {
    this.getBuild()
  },

  methods: {
    getBuild() {
      this.$axios
        .get('version')
        .then(res => {
          this.back_build = res.data.version
          this.showVersija = true
        })
        .catch(err => {
          //
        })
    },
    gotoPagaba() {
      window.open('https://info.registrucentras.lt/')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/elementsTheme.scss';
.footer-title {
  color: $secondary;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}
.footer-text {
  color: $defaultText;
  font-size: 10px;
  font-weight: 400;
}
ul {
  padding-left: 0 !important;
}
li {
  color: var(--v-primary-base);
  list-style-type: none;
  font-size: 10px;
}
.address {
  font-size: 8px;
  color: $secondary;
}
.logo {
  width: 100%;
  max-width: 150px;
}
.kmlogo {
  width: 100%;
  max-width: 180px;
}
.version {
  color: $secondary;
  font-size: 14px;
  font-weight: 400;
}
.pagalba {
  cursor: pointer;
}
</style>
